export const API_ENDPOINTS = {
  // Homepage
  SAVE_HOMEPAGE: "/homepage/save",
  HOMEPAGE_DETAIL: "/homepage/detail",

  // Page
  SAVE_PAGE: "/page/save",
  PAGE_DETAIL: "/page/detail",

  // Contact Form
  LIST_CONTACT: "/contact/list",
  DELETE_CONTACT: "/contact/delete",

  // Insight
  SAVE_INSIGHT: "/insight/save",
  LIST_INSIGHT: "/insight/list",
  DELETE_INSIGHT: "/insight/delete",

  //ADMIN

  ADMIN_LOGIN: "/admin/login",
  USER_DELETE: "/delete",
  ADMIN_DETAIL: "/admin/profile",
  ADMIN_SAVE: "/admin/save-profile",
  VALIDATE_TOKEN: "/validate-token",
  ADMIN_UPDATE_PASSWORD: "/admin/update-password",

  // FILE
  FILE_LIST: "/file/list",
  FILE_SAVE: "/file/save",
  FILE_DELETE: "/file/remove",
  FILE_UPLOAD: "/file/upload",
  FILE_DOWNLOAD: "/file/download",
  FILE_PREVIEW: "/file/preview",
  FILE_REMOVE: "/file/remove",


  SERVICE_LIST: "/service/list",
  SERVICE_DETAIL: "/service/detail",
  SERVICE_SAVE: "/service/save",
  SERVICE_DELETE: "/service/delete",

  INDUSTRY_SAVE: "/industry/save",
  INDUSTRY_LIST: "/industry/list",
  INDUSTRY_DELETE: "/industry/delete",
  INDUSTRY_DETAIL: "/industry/detail",
  SETTING_LIST: "/restaurant-setting/list",
  SETTING_SAVE: "/restaurant-setting/save",
  SETTING_DELETE: "/restaurant-setting/delete",

  USER_LIST: "/user/list",
  USER_DETAIL: "/user/detail",

  USER_SAVE: "/admin/update-profile",
  USER_UPDATE_PASSWORD: "/admin/update-password",
  USER_UPDATE_RESTAURANT_PROFILE: "/admin/update-restaurant-profile",

  //consultation
  CONSULTATION_LIST: "/consultation-booking/list",
  CONSULTATION_UPDATE: "/consultation-booking/update",
  CONSULTATION_DELETE: "/consultation-booking/delete",
  CONSULTATION_DETAIL: "/consultation-booking/detail",

  //document
  DOCUMENT_LIST: "/document/list",
  DOCUMENT_DETAIL: "/document/detail",
  DOCUMENT_UPDATE: "/document/update-status",

  //account
  ACCOUNTANT_LIST: "/accountant/list",
  ACCOUNTANT_DETAIL: "/accountant/detail",
  ACCOUNTANT_CREATE: "/accountant/create",
  ACCOUNTANT_UPDATE: "/accountant/update",
  ACCOUNTANT_DELETE: "/accountant/delete",

  //dynamic form
  DYNAMIC_FORM_LIST: "/dynamic-form/fields/list",
  DYNAMIC_FORM_DETAIL: "/dynamic-form/fields/detail",
  DYNAMIC_FORM_CREATE: "/dynamic-form/fields/create",
  DYNAMIC_FORM_DELETE: "/dynamic-form/fields/delete",

  //web info
  WEB_INFO_LIST: "/web-info/list",
  WEB_INFO_SAVE: "/web-info/create",
  WEB_INFO_DETAIL: "/web-info/detail",

  //sub admins
  SUB_ADMINS_LIST: "/admin/sub-admin/list",
  SUB_ADMINS_CREATE: "/admin/sub-admin/save",
  SUB_ADMINS_UPDATE: "/admin/sub-admin/update",
  SUB_ADMINS_DETAILS: "/admin/sub-admin/details",

  //notification
  NOTIFICATION_LIST: "/notification/list",
  NOTIFICATION_MARK_ALL_READ: "/notification/mark-all-read",

  // dashboard
  DASHBOARD_STATS: "/dashboard/stats",

  // Filling management list
  FILLING_MANAGEMENT_LIST: "/filling-management/list",
  SEND_REMINDER: "/filling-management/send-reminder",

  TRANSACTION_LIST: "/transaction/list",
};
